// Hover tooltip explaining why an action is disabled — or, with tone="info", warning
// about what the action will cost.
//
// Red (default) matches the pending-payment AlertMessage above "Your Next Ride" (#f07171
// with dark text): a blocked action is a problem, so it reads in the same colour as the
// other problem states. tone="info" uses the neutral #3c393c bubble the edit page shows
// over its submit button, for a hint about an action that IS still allowed.
//
// The parent must be `relative group`; render this next to the control.
const TONES = {
    blocked: 'bg-[#f07171] text-(--text-primary) font-semibold after:border-b-[#f07171]',
    // Informational, not an error — regular weight, like the edit page's own bubble.
    info: 'bg-[#3c393c] text-white font-normal after:border-b-[#3c393c]',
}

export default function BlockedTooltip({children, tone = 'blocked'}) {
    return (
        <span className={`hidden group-hover:block absolute top-full right-0 mt-3 rounded-2xl px-3 py-2.5 text-xs text-center w-max max-w-[220px] shadow-[0_8px_24px_rgba(0,0,0,0.18)] z-30 after:content-[''] after:absolute after:bottom-full after:right-6 after:border-[8px] after:border-transparent ${TONES[tone] || TONES.blocked}`}>
            {children}
        </span>
    )
}
